<template>
  <div>
    <input :class="getInputClass()" type="text" v-model="data" :placeholder="placeholder" v-if="showPassword">
    <input :class="getInputClass()" type="password" v-model="data" :placeholder="placeholder" v-else>

    <i class="bi bi-sunglasses" style="max-height:10px;font-size:1.3rem;float:right;position:relative;top:-30px;right:15px;margin-bottom:0px;" @click="showPassword=!showPassword;" v-if="showPassword">
      <small style="font-size: 0.9rem;">
        Ocultar Contraseña
      </small>
    </i>
    <i class="bi bi-eyeglasses" style="max-height:1px;font-size:1.3rem;float:right;position:relative;top:-30px;right:15px;margin-bottom:0px;" @click="showPassword=!showPassword;" v-else>
      <small style="font-size: 0.9rem;">
        Mostrar Contraseña
      </small>
    </i>
    
  </div>
</template>
<script>

export default{
 name:'InputPassword',
 data:function(){
  return{
    data:'',
    state:0,
    showPassword:false
  };
 },
 props:{
  propName:String,
  placeholder:String,
  maxLength:Number,
  minLength:Number,
  capital:Boolean,
  mode:String,
  ref:String 

 },

 mounted:function(){
  
  this.data=this.$parent.formData[''+this.propName].data;
  this.state=this.$root.verifData(this.data, this.mode, this.minLength, this.maxLength);
  //console.log("inputText Mounted data: "+this.data);

 },
 watch:{
  data:function(){

    if(this.capital){
      this.data=this.data.toUpperCase();
    }
    if(this.data.length>this.maxLength){
      this.data=this.data.substring(0,this.maxLength);
    }

    this.state=this.$root.verifData(this.data, this.mode, this.minLength, this.maxLength);
    if(this.propName!=''){
        //this.$parent[''+this.propName]=this.data;
        
        this.$parent.formData[''+this.propName]={data:''+this.data,state:this.state};
        //console.log("actualizando valor de "+this.propName);
    }

  }
 },
 methods:{

  updateData(val){
    console.log("updateData()");
    this.data=val;

  },

  getData(){
    return this.data;
  },
  getBState(){
    return (this.state==1);
  },
  
  getInputClass(){    

    let classStr={};

    classStr={
        '-1':"inputError",
        '0':'input',
        '1':'inputCorrect'
    };

    return classStr[''+this.state];
  },

  


 }
}
</script>
<style scoped>

</style>
